//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MillOperationBuilder.js";
import "../CAM/CAM.AvoidanceMethodsBuilder.js";
import "../CAM/CAM.StepoverBuilder.js";
import "../CAM/CAM.Geometry.js";
import "../CAM/CAM.CutPatternBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.NcmPlanarBuilder.js";
import "../CAM/CAM.ToolAxisFixed.js";
let d=[[[0,"AdditionalPasses",1,0],[0,"AutomaticPartBoundaryMethod",1,0],[1,"AvoidanceMethods",0,"CAM.AvoidanceMethodsBuilder",0],[1,"BndStepover",0,"CAM.StepoverBuilder",0],[1,"CheckGeometry",0,"CAM.Geometry",0],[0,"CornerLoops",1,0],[1,"CutAreaGeometry",0,"CAM.Geometry",0],[1,"CutPattern",0,"CAM.CutPatternBuilder",0],[0,"DeferCuttingStatus",1,0],[1,"DepthPerCut",0,"CAM.InheritableDoubleBuilder",0],[0,"IslandCleanup",1,0],[1,"NonCuttingBuilder",0,"CAM.NcmPlanarBuilder",0],[1,"PartGeometry",0,"CAM.Geometry",0],[1,"ToolAxisFix",0,"CAM.ToolAxisFixed",0],[0,"ToolMinimumLengthUsage",1,0]],[],[]];
SPLM.CAM.PlanarOperationBuilder = class extends SPLM.CAM.MillOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.PlanarOperationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.PlanarOperationBuilder.AutomaticPartBoundaryMethodTypes = Object.freeze({
    "FollowWallBottom" : "FollowWallBottom", "FollowWallTop" : "FollowWallTop"});

export default SPLM;